import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'mtn-drive-time-minutes-field',
  templateUrl: './drive-time-minutes-field.component.html',
  styleUrls: ['./drive-time-minutes-field.component.scss']
})
export class DriveTimeMinutesFieldComponent {

  @Input()
  form: UntypedFormGroup;
  @Input()
  controlName: string = 'driveTimeMinutes';
  @Input()
  placeholder: string = 'Minutes';
  
  constructor() {
  }


  onInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const value = Number(input.value);
    const control = this.form.get(this.controlName);
    this.form.markAllAsTouched();
    this.form.markAsDirty();
    if (value > 20) {
      input.value = '20';
      control.setValue(20);
      control.setErrors({ ...(control.errors || {}), max: true });
    }else {
      if (control.hasError('max')) {
        const newErrors = { ...control.errors };
        delete newErrors['max'];
        control.setErrors(Object.keys(newErrors).length ? newErrors : null);
      }
    }

    if (value < 1) {
      input.value = '1';
      control.setValue('');
      control.setErrors({ ...(control.errors || {}), min: true });
    } else {
      if (control.hasError('min')) {
        const newErrors = { ...control.errors };
        delete newErrors['min'];
        control.setErrors(Object.keys(newErrors).length ? newErrors : null);
      }
    }
  }

}


